// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abc4a0cc","667":"e0464585","977":"fbad9e55"}[chunkId] + ".chunk.js";
};